"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCoreDataSecurityMonitorsAllSyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const get_1 = require("./get.js");
exports.updateCoreDataSecurityMonitorsAllSyncSlice = (0, xuder_1.createUpdateCollectionSyncSlice)({
    hasRequest: true,
    name: name_1.CoreDataSecurityMonitorsAllName,
    state: get_1.getCoreDataSecurityMonitorsAllSlice.asyncState,
    target: (request) => (monitor) => monitor.id === request.id,
    update: (request) => (monitor) => (Object.assign(Object.assign({}, monitor), request))
});
//# sourceMappingURL=update.js.map